require("@polleverywhere/toolkit/lib/foreman_env.js.erb")
PollEv.env.set({
  
  slides_server_url: 'PLACEHOLDER_SLIDES_SERVER_URL_PLACEHOLDER',
  

  

  
  google_tag_manager_id: 'PLACEHOLDER_GOOGLE_TAG_MANAGER_ID_PLACEHOLDER'
  
})
